import React from 'react';

function YesNo(props) {
    return (
        <span
            style={{
                fontSize: '13px',
                fontWeight: '500',
                color: 'var(--black)'
            }}
        >
            {props.value === undefined ? 'N/A' : props.value ? 'Yes' : 'No'}
        </span>
    );
}

export default YesNo;
